exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-upload-img .el-form-item__content img {\n  width: 200px;\n  margin-right: 10px;\n  display: inline-block;\n}\n", ""]);

// exports
